module.exports = __webpack_public_path__ + "img/brentford-fc.0f86dd32.png";